/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainerType, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainerTypesController.
 */
export class ContainerTypesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /container_types:prefill
     */
    public createPrefilled(): Promise<Result<ApiContainerType>> {
        return this.http.post<Result<ApiContainerType>, undefined>('/container_types:prefill', undefined);
    }

    /**
     * Calls GET /container_types:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiContainerType>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiContainerType>>>('/container_types:query', query);
    }

    /**
     * Calls POST /container_types:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiContainerType>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiContainerType>>, ListRequest>('/container_types:query', listRequest, query);
    }

    /**
     * Calls POST /container_types:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiContainerType>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiContainerType>>, ListRequestWithIds>('/container_types:batch', listRequest, query);
    }

    /**
     * Calls GET /container_types/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiContainerType>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiContainerType>>(`/container_types/${primaryId}`, query);
    }

    /**
     * Calls POST /container_types
     */
    public add(dto: ApiContainerType): Promise<Result<ApiContainerType>> {
        return this.http.post<Result<ApiContainerType>, ApiContainerType>('/container_types', dto);
    }

    /**
     * Calls PUT /container_types/{primaryId}
     */
    public update(dto: ApiContainerType, primaryId: string): Promise<Result<ApiContainerType>> {
        return this.http.put<Result<ApiContainerType>, ApiContainerType>(`/container_types/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /container_types
     */
    public putRange(dtos: ApiContainerType[]): Promise<Result<ApiContainerType[]>> {
        return this.http.patch<Result<ApiContainerType[]>, ApiContainerType[]>('/container_types', dtos);
    }

    /**
     * Calls DELETE /container_types/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/container_types/${primaryId}`);
    }

    /**
     * Calls POST /container_types/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiContainerType>> {
        return this.http.post<Result<ApiContainerType>, undefined>(`/container_types/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /container_types/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiContainerType>>> {
        return this.http.post<Result<LockedContextDto<ApiContainerType>>, undefined>(`/container_types/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /container_types/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiContainerType[]>> {
        return this.http.post<Result<ApiContainerType[]>, string[]>('/container_types/locks', ids);
    }

    /**
     * Calls POST /container_types/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/container_types/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /container_types/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/container_types/${primaryId}/locks`);
    }
}
